import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { content: String, feedbackText: String }
  static targets = ['button']

  copy() {
    navigator.clipboard.writeText(this.contentValue)

    if (this.hasButtonTarget && this.hasFeedbackTextValue) {
      const original = this.buttonTarget.textContent
      this.buttonTarget.textContent = this.feedbackTextValue
      setTimeout(() => {
        this.buttonTarget.textContent = original
      }, 2000)
    }
  }
}